import {PaymentProvider} from '@/constants/payment-provider';
import BaseProvider from '@/utils/checkout/payment-providers/base-provider';

class IdealProvider extends BaseProvider {
  constructor(options) {
    super(options);
    const {bankName, billingAddress, providerCode} = options;

    this.bankName = bankName;
    this.billingAddress = billingAddress;

    this.providerCode =
      providerCode === PaymentProvider.GR4VY_IDEAL ? PaymentProvider.GR4VY_IDEAL : PaymentProvider.CYBERSOURCE_IDEAL;
  }

  async initializePayment() {
    const data = {
      billingAddress: this.billingAddress,
      paymentProviderCode: this.providerCode,
      paymentOption: this.providerCode === 'GR4VY_IDEAL' ? 'gr4vy_ideal' : this.bankName,
    };
    return this.submitPaymentInitForm(data);
  }
}

export default IdealProvider;
